import React, { useState } from 'react';

import './styles/index.css';

import PlaySound from './playsound';
import DisplayPanel from './tools/displayPanel'
import SummaryView from './tools/summary'

import { Col, Row } from 'react-bootstrap';


/*
This is the container to hold the grid and display panel

The structure as follows:

game.js             -> container to hold the grid and display panel
                    -> the parent to control the interaction between the playsound.js and displayPanel.js

playsound.js        -> retrieve all game related data from python API from database 
                    -> compute the positions of notations on the grid
                    -> sends the computed position to gridButton.js
                    -> when user submits a combination, the current computed position of the grid will be send to game.js as well
                    -> when game.js recieves the computed position, it will pass it back to the playsound.js so that it will not generate a new set of positions
                    -> if no computed position is sent to game.js, game.js will send an empty grid to playsound.js and playsound.js will re-generate the new positions

gridButton.js       -> recieves computed position, answers, adjacent postion, noation details from playsound.js
                    -> display grid
                    -> import sound from sound.js
                    -> play sound
                    -> collects notations click by user
                    -> on submit, check number of selected notation, verify with answer and assign score
                    -> pass submited notation and score to playsound.js and playsound.js pass this data to game.js to update display panel
                    -> on reset, clear currently selected notations
                    -> on shuffle, send empty submitted combination and empty computed position to game.js
                    -> on new game, send new game flag to game.js to reset grid and results 

sound.js            -> import physical sound into project

displaPanel.js      -> recieves an array of submitted combinations from game.js 
                    -> display list of sunmitted combinations in reverse order. latest submited combination on top of the list
                    -> imports sound from sound.js
                    -> play s series of sound within combination using interval timer
                    -> if game.js sends an empty array, clear display list
grouping            -> public users will not need to enter a group code
                    -> users with group code will have their own leaderboard, having scores grouped together using that group code
                    -> a pre-defined prefix is stored in the database
                    -> when user keys in a group code, it needs to match one of the prefix in the database
                    -> group codes are like tags for user's score. Pre-creation of group codes is not necessary
                    -> there isn’t a restriction on the maximum number of characters for the group code
leaderboard         -> only top 5 users of each duration tier and average time are displayed
                    -> For subsequent games, as long as the users key in the same code, their high scores will be recorded in the same leaderboard
                    -> average time is  calcuated using the total correct answers divide by the total duration of the game the user has selected
special character   -> for ii∅7, as database does not accept this "∅" character, i have used "~" as a replacement for this character in the database
                    -> in the codes, if "~" is detect, it will be replaced with the "∅" character

*/

export default function Game(props) {
    const [results, setResults] = useState([]);
    const [totalscore, setTotalscore] = useState(0);
    const [totalcorrect, setTotalcorrect] = useState(0);
    const [gridcomplete, setGridcomplete] = useState([]);
    const { selectRestart } = props; //to pass callback


    //check that both array is identical
    const arraysEqual = (a, b) => {


        for (var i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        if (a.length === b.length) //to compare the same number of chords. if a has 3 chords and b has 4 chords, return false
            return true;
        else
            return false;
    }


    const onSelectResults = (word, gridcomplete, purpose) => {
        let myresults = [...results];

        if (word !== "") { //when word == "", it means it is used for reshuffle

            //search for duplicated answers
            if (myresults.length > 0) {

                for (var j = 0; j < myresults.length; j++) {
                    if (arraysEqual(word[0].combi, myresults[j].combi)) {
                        word[0].score = "-";
                        break;
                    }
                }
            }

            myresults.push(word[0]);
            setGridcomplete(gridcomplete);
            setResults(myresults)


            //calculate total score
            let myscore = 0;

            //sum total number of correct combinations
            let mycorrect = 0;


            for (var i = 0; i < myresults.length; i++) {
                if (myresults[i].score !== "-")
                    myscore += parseInt(myresults[i].score);
                if (myresults[i].score !== "-" && myresults[i].score > 0)
                    mycorrect += 1;
            }

            setTotalscore(myscore);
            setTotalcorrect(mycorrect);

        } else {
            if (purpose === "restart" || purpose === "newgame") {
                setResults([]);
                selectRestart(purpose) // send flag to gameholder.js to start a new game
                setTotalscore(0);
                setTotalcorrect(0);
            }

            //reshuffle grid
            setGridcomplete([]);
        }

    }


    return (

        <Row >

            <Col xs={12} md={12} lg={12} xl={6}>
                <DisplayPanel results={results} totalscore={totalscore} chord={props.chord} volume={props.volume} />
            </Col>
            <Col xs={12} md={12} lg={12} xl={6} className="text-center" id="non-printable">
                <PlaySound type={props.type} oldGrid={gridcomplete} selectResults={onSelectResults} timerHasStopped={props.timerStoped} chord={props.chord} duration={props.duration} volume={props.volume} />
            </Col>
            {props.timerStoped === true && <SummaryView totalscore={totalscore} duration={props.duration} type={props.type} totalcorrect={totalcorrect} groupcode={props.groupcode}/>}

        </Row>




    )
}